import { SVGProps } from 'react';

const FileAudio2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2m10-4v4a2 2 0 0 0 2 2h4M2 17a1 1 0 1 0 2 0 1 1 0 0 0-2 0m0 0v-3a4 4 0 1 1 8 0v3m0 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    />
  </svg>
);
export default FileAudio2;
